import BackboneSessionHelper from '../util/backbone_session_helper'

export default class State extends Backbone.Model {
  get defaults () {
    return {
      user: null,
      participant: null
    }
  }

  get user () {
    return this.get('user')
  }

  get participant () {
    return this.get('participant')
  }

  get legacySession () {
    return this.backboneSessionHelper.session
  }

  initialize (attrs = {}, options = {}) {
    this.backboneSessionHelper = new BackboneSessionHelper(this).startSyncing()
  }

  inspect () {
    const result = super.toJSON()

    // Deal with state model attributes whose values are complex types
    result.participant = this.get('participant')?.toJSON()
    result.settings = this.get('settings')?.toJSON()
    result.user = this.get('user')?.toJSON().user

    return result
  }

  destroy () {
    this.backboneSessionHelper.stopSyncing()
  }
}
